const itemsMenu = {
    SUJETO: { valor: 100, descripcion: "Sujeto" },
    SUJETOS: { valor: 103, descripcion: "Sujetos" },
    IMPORTARARCHIVO: { valor: 104, descripcion: "Importar Archivo" },
    TIPOCONTACTO: { valor: 202, descripcion: "Tipos de Contacto" },
    TIPOIDENTIFICACION: { valor: 204, descripcion: "Tipos de Identificación" },
    ORIGENES: { valor: 203, descripcion: "Orígenes" },
    PRIORIDADCONTACTO: { valor: 205, descripcion: "Prioridades de Contacto" },
    ORGANISMO: { valor: 200, descripcion: "Configuraciones" },
    ORGANISMOS: { valor: 201, descripcion: "Organismos" },
    CASOETAPA: { valor: 206, descripcion: "Instancias del Caso" },
    MENSAJES: { valor: 209, descripcion: "Mensajes" },
    MOTIVOCUALITATIVO: { valor: 210, descripcion: "Motivos de Campaña Cualitativa" },
    
    CONFIGURACIONES_PREJUDICIALES: { valor: 240, descripcion: "Configuraciones Pre-Judicial" },
    CASOESTADO: { valor: 207, descripcion: "Estados de la Gestion" },
    CASOEVENTOTIPO: { valor: 208, descripcion: "Tipos de Evento" },
    
    CONFIGURACIONES_JUDICIALES: { valor: 280, descripcion: "Configuraciones Judicial" },
    CASOESTADOJUDICIAL: { valor: 281, descripcion: "Estados Judiciales" },
    CASOEVENTOTIPOJUDICIAL: { valor: 282, descripcion: "Tipos de Evento Judicial" },
    JUDEVENTORESTRICCION: { valor: 283, descripcion: "Restricciones de Eventos" },

    CONFIGURACIONES_CASOS_CUALITATIVOS: { valor: 320, descripcion: "Configuraciones Casos Cualitativos" },
    CASOCUALITATIVOESTADO: { valor: 321, descripcion: "Estados de la Gestion (Cualitativos)" },
    CASOCUALITATIVOEVENTOTIPO: { valor: 322, descripcion: "Tipos de Evento (Cualitativos)" },
    
    CASOS: { valor: 300, descripcion: "Gestión de Casos" },
    LISTARCASOSPREJUDICIAL: { valor: 301, descripcion: "Gestion Pre-Judicial" },
    LISTARCASOSJUDICIAL: { valor: 302, descripcion: "Gestion Judicial" },
    LISTARCASOSCUALITATIVOS: { valor: 308, descripcion: "Gestion de Casos Cualitativos" },
    HISTORIALCASOS: { valor: 307, descripcion: "Historial de Casos" },
    AGENDARCASO: { valor: 303, descripcion: "Agendar Caso" },
    CAMBIARESTADOCASO: { valor: 304, descripcion: "Cambiar Estado Caso" },
    SEGUIMIENTOCASO: { valor: 305, descripcion: "Seguimiento Caso" },
    TRASPASARCASO: { valor: 306, descripcion: "Traspasar Caso" },

    SEGURIDAD: { valor: 400, descripcion: "Seguridad"},
    USUARIOS: { valor: 401, descripcion: "Usuarios"},
    PERFILES: { valor: 402, descripcion: "Perfiles"},
    ROLES: { valor: 403, descripcion: "Roles"},
    CHANGEPASSWORD: { valor: 404, descripcion: "cambiarcontrasenia"},
    AUDITORIA: { valor: 600, descripcion: "Auditoria"},
    NOCONFORMIDAD: { valor: 601, descripcion: "No Conformidad"},
    TRATAMIENTOSNOCONFORMIDAD: { valor: 602, descripcion: "Tratamientos No Conformidad"},
    MODULOBI: { valor: 603, descripcion: "Analisis e Informes"},
    CTROLASISTENCIA: { valor: 605, descripcion: "Control de Asistencias"},
  };
  
  export default itemsMenu;